<template>
  <div class="aboutWrapper">
    <dwgwcontenheader :imgsrc="img"></dwgwcontenheader>
    <dwgwggtabs :contentsList="contentsList">
    </dwgwggtabs>
  </div>
</template>

<script>
import dwgwcontenheader from "@/components/dwgwcontenheader";
import dwgwggtabs from "@/components/dwgwggtabs";
export default {
  name: "dwgwagg",
  components: {
    dwgwcontenheader,
    dwgwggtabs,
  },
  data() {
    return {
      img: require("./jpg/index1_4.png"),
      contentsList: [
        {
          title: "重大变更公告1",
          rightInfo: ["浙江蝶威资产管理有限公司", "2020-9-28"],
          contentData: [
            "根据公司发展情况需要，于2020年9月11日召开股东会决议，任命魏铭三为公司新法定代表人、执行董事，原法定代表人、执行董事费革胜改任投资决策委员会主席。现公司已完成工商变更，已于2020年9月17日生效。",
            "特此公告！",
          ],
        },
        {
          title: "重大变更公告2",
          rightInfo: ["浙江蝶威资产管理有限公司", "2020-9-28"],
          contentData: [
            "根据公司发展情况需要，于2020年9月11日召开股东会决议，任命魏铭三为公司新法定代表人、执行董事，原法定代表人、执行董事费革胜改任投资决策委员会主席。现公司已完成工商变更，已于2020年9月17日生效。",
            "特此公",
          ],
        },
        {
          title: "重大变更公告3",
          rightInfo: ["浙江蝶威资产管理有限公司", "2020-9-28"],
          contentData: [
            "根据公司发展情况需要，于2020年9月11日召开股东会决议，任命魏铭三为公司新法定代表人、执行董事，原法定代表人、执行董事费革胜改任投资决策委员会主席。现公司已完成工商变更，已于2020年9月17日生效。",
            "特此公告3",
          ],
        },
      ],
    };
  },
};
</script>

<style scoped>
.aboutWrapper {
  width: 1140px;
  margin: 0 auto;
  margin-top: 100px;
}
.xiaomishuImg {
  width: 50%;
}
.floatRigth > p {
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/dwgwgg.vue